export default __webpack_public_path__ + "static/media/error.3ad41351.svg";